export default __webpack_public_path__ + "static/media/caret-right-solid.7e632a10.svg";